"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDeferredJobsApiClient = createDeferredJobsApiClient;
var _progressPromise = require("@prezly/progress-promise");
var _index = require("../http/index.cjs");
var _routing = require("../routing.cjs");
var _index2 = require("../types/index.cjs");
const JOB_STATUS_POLLING_INTERVAL = 2000; // ms

async function sleep(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}
function handleDeferredJob(api, request) {
  return new _progressPromise.ProgressPromise(async (resolve, reject, update) => {
    try {
      const response = await request;
      if (response.status === _index.HttpCodes.ACCEPTED && (0, _index.isDeferredJobResponse)(response.payload)) {
        const id = response.payload.progress.id;
        do {
          const response = await api.get(`${_routing.routing.jobsUrl}/${id}`, {
            fetch
          });
          const state = response.payload.job.state;
          if (state.status === _index2.JobStatus.RESOLVED) {
            resolve(state.value);
            return;
          }
          if (state.status === _index2.JobStatus.REJECTED) {
            reject(state.value);
            return;
          }
          update(state.progress, state.value);
          await sleep(JOB_STATUS_POLLING_INTERVAL);
        } while (true); // eslint-disable-line no-constant-condition
      }
      resolve(response.payload);
    } catch (error) {
      reject(error);
    }
  });
}
function createDeferredJobsApiClient(api) {
  function get(url, {
    headers,
    query
  } = {}) {
    return handleDeferredJob(api, api.get(url, {
      headers,
      query
    }));
  }
  function post(url, {
    headers,
    payload,
    query
  } = {}) {
    return handleDeferredJob(api, api.post(url, {
      headers,
      payload,
      query
    }));
  }
  function put(url, {
    headers,
    payload,
    query
  } = {}) {
    return handleDeferredJob(api, api.put(url, {
      headers,
      payload,
      query
    }));
  }
  function patch(url, {
    headers,
    payload,
    query
  } = {}) {
    return handleDeferredJob(api, api.patch(url, {
      headers,
      payload,
      query
    }));
  }
  function doDelete(url, {
    headers,
    payload,
    query
  } = {}) {
    return handleDeferredJob(api, api.delete(url, {
      headers,
      payload,
      query
    }));
  }
  return {
    get,
    post,
    put,
    patch,
    delete: doDelete
  };
}